"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
exports.reduceObject = function (iteratorFunction, initialValue, object) {
    return ramda_1.pipe(ramda_1.keys, ramda_1.reduce(function (acc, property) { return iteratorFunction(acc, object[property], property); }, initialValue))(object);
};
//# sourceMappingURL=reduce-object.js.map